document.addEventListener('DOMContentLoaded', function () {

    var auth     = window.MD_Firebase ? window.MD_Firebase.getAuth() : null;
    var form     = document.getElementById('form-login');
    var inputEmail  = document.getElementById('login-email');
    var inputPass   = document.getElementById('login-password');
    var btnLogin    = document.getElementById('btn-login');
    var errorMsg    = document.getElementById('login-error');

    if (!form || !auth) return;

    form.addEventListener('submit', function (e) {
        e.preventDefault();

        var email = inputEmail.value.trim();
        var pass  = inputPass.value;

        if (!email || !pass) {
            mostrarError('Ingresa correo y contraseña.');
            return;
        }

        btnLogin.disabled    = true;
        btnLogin.textContent = 'Entrando...';
        ocultarError();

        auth.signInWithEmailAndPassword(email, pass)
            .then(function () {
                window.location.href = '/proyectos';
            })
            .catch(function (err) {
                btnLogin.disabled    = false;
                btnLogin.textContent = 'Entrar';
                mostrarError(mensajeError(err.code));
            });
    });

    function mostrarError(msg) {
        errorMsg.textContent    = msg;
        errorMsg.style.display  = 'block';
    }

    function ocultarError() {
        errorMsg.style.display = 'none';
        errorMsg.textContent   = '';
    }

    function mensajeError(code) {
        switch (code) {
            case 'auth/user-not-found':
            case 'auth/wrong-password':
            case 'auth/invalid-credential':
                return 'Correo o contraseña incorrectos.';
            case 'auth/too-many-requests':
                return 'Demasiados intentos. Espera un momento.';
            case 'auth/invalid-email':
                return 'El correo no tiene un formato válido.';
            default:
                return 'Error al iniciar sesión. Intenta de nuevo.';
        }
    }

});
